import { createFileRoute } from '@tanstack/react-router'
import { BroadcastsPageClient } from '#/components/broadcasts/BroadcastsPageClient'

export const Route = createFileRoute('/_authenticated/$slug/broadcasts')({
  component: BroadcastsPageClient,
})
